// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PCalendarOutlinedSvg from "@fishx/icons-svg/es/asn/PCalendarOutlined";
import FishxIcon from '../components/FishxIcon';

var PCalendarOutlined = function PCalendarOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PCalendarOutlinedSvg
  }));
};

PCalendarOutlined.displayName = 'PCalendarOutlined';
export default React.forwardRef(PCalendarOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PCalendarOutlined.js
// module id = 3259
// module chunks = 0